export const EngineABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_DEFAULT_MONS_PER_TEAM",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "_DEFAULT_MOVES_PER_MON",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "DEFAULT_MONS_PER_TEAM",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "DEFAULT_MOVES_PER_MON",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "addEffect",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "effect",
        "type": "address",
        "internalType": "contract IEffect"
      },
      {
        "name": "extraData",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "addStatBoost",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "statBoostsToApply",
        "type": "tuple[]",
        "internalType": "struct StatBoostToApply[]",
        "components": [
          {
            "name": "stat",
            "type": "uint8",
            "internalType": "enum MonStateIndexName"
          },
          {
            "name": "boostPercent",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "boostType",
            "type": "uint8",
            "internalType": "enum StatBoostType"
          }
        ]
      },
      {
        "name": "boostFlag",
        "type": "uint8",
        "internalType": "enum StatBoostFlag"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "battleKeyForWrite",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "clearAllStatBoosts",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "clearMonStatus",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "expectedClass",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "cleared",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "computeBattleKey",
    "inputs": [
      {
        "name": "p0",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p1",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "pairHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "computePartyKey",
    "inputs": [
      {
        "name": "p0",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p1",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p2",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p3",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "partyHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "dealDamage",
    "inputs": [
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "damage",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "dispatchCustomAttack",
    "inputs": [
      {
        "name": "attackerPlayerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "attackerMonIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "targetBits",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "basePower",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "accuracy",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "volatility",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "moveType",
        "type": "uint8",
        "internalType": "enum Type"
      },
      {
        "name": "moveClass",
        "type": "uint8",
        "internalType": "enum MoveClass"
      },
      {
        "name": "rng",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "critRate",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "damage",
        "type": "int32",
        "internalType": "int32"
      },
      {
        "name": "eventType",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "dispatchCustomAttackMulti",
    "inputs": [
      {
        "name": "attackerPlayerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "attackerMonIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "targetBits",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "basePower",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "accuracy",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "volatility",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "moveType",
        "type": "uint8",
        "internalType": "enum Type"
      },
      {
        "name": "moveClass",
        "type": "uint8",
        "internalType": "enum MoveClass"
      },
      {
        "name": "rng",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "critRate",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "totalDamage",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "dispatchStandardAttack",
    "inputs": [
      {
        "name": "attackerPlayerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "attackerMonIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "targetBits",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "basePower",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "accuracy",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "volatility",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "moveType",
        "type": "uint8",
        "internalType": "enum Type"
      },
      {
        "name": "moveClass",
        "type": "uint8",
        "internalType": "enum MoveClass"
      },
      {
        "name": "critRate",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "effectAccuracy",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "effect",
        "type": "address",
        "internalType": "contract IEffect"
      },
      {
        "name": "rng",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "damage",
        "type": "int32",
        "internalType": "int32"
      },
      {
        "name": "eventType",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "editEffect",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "effectIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "newExtraData",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "eip712Domain",
    "inputs": [],
    "outputs": [
      {
        "name": "fields",
        "type": "bytes1",
        "internalType": "bytes1"
      },
      {
        "name": "name",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "version",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "chainId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "verifyingContract",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "salt",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "extensions",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "end",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "execute",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeBatchedSlotTurns",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "entries",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "executed",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeBatchedTurns",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "entries",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "executed",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeBuffered",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeWithMoves",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "p0MoveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "p0Salt",
        "type": "uint104",
        "internalType": "uint104"
      },
      {
        "name": "p0ExtraData",
        "type": "uint16",
        "internalType": "uint16"
      },
      {
        "name": "p1MoveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "p1Salt",
        "type": "uint104",
        "internalType": "uint104"
      },
      {
        "name": "p1ExtraData",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeWithSingleMove",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "moveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "salt",
        "type": "uint104",
        "internalType": "uint104"
      },
      {
        "name": "extraData",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeWithSlotMoves",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "side0Packed",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "side1Packed",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "forfeit",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "getActiveSlots",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "slots",
        "type": "uint256[4]",
        "internalType": "uint256[4]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getBattle",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct BattleConfigView",
        "components": [
          {
            "name": "rngOracle",
            "type": "address",
            "internalType": "contract IRandomnessOracle"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "globalEffectsLength",
            "type": "uint24",
            "internalType": "uint24"
          },
          {
            "name": "packedP0EffectsCount",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "packedP1EffectsCount",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "teamSizes",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "startTimestamp",
            "type": "uint40",
            "internalType": "uint40"
          },
          {
            "name": "p0Salt",
            "type": "uint104",
            "internalType": "uint104"
          },
          {
            "name": "p1Salt",
            "type": "uint104",
            "internalType": "uint104"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "monStatusLanes",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "playerEffectStepsByMon",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "p0Move",
            "type": "tuple",
            "internalType": "struct MoveDecision",
            "components": [
              {
                "name": "packedMoveIndex",
                "type": "uint8",
                "internalType": "uint8"
              },
              {
                "name": "extraData",
                "type": "uint16",
                "internalType": "uint16"
              }
            ]
          },
          {
            "name": "p1Move",
            "type": "tuple",
            "internalType": "struct MoveDecision",
            "components": [
              {
                "name": "packedMoveIndex",
                "type": "uint8",
                "internalType": "uint8"
              },
              {
                "name": "extraData",
                "type": "uint16",
                "internalType": "uint16"
              }
            ]
          },
          {
            "name": "globalEffects",
            "type": "tuple[]",
            "internalType": "struct EffectInstance[]",
            "components": [
              {
                "name": "effect",
                "type": "address",
                "internalType": "contract IEffect"
              },
              {
                "name": "stepsBitmap",
                "type": "uint16",
                "internalType": "uint16"
              },
              {
                "name": "data",
                "type": "bytes32",
                "internalType": "bytes32"
              }
            ]
          },
          {
            "name": "p0StatBoosts",
            "type": "bytes32[][]",
            "internalType": "bytes32[][]"
          },
          {
            "name": "p1StatBoosts",
            "type": "bytes32[][]",
            "internalType": "bytes32[][]"
          },
          {
            "name": "p0Effects",
            "type": "tuple[][]",
            "internalType": "struct EffectInstance[][]",
            "components": [
              {
                "name": "effect",
                "type": "address",
                "internalType": "contract IEffect"
              },
              {
                "name": "stepsBitmap",
                "type": "uint16",
                "internalType": "uint16"
              },
              {
                "name": "data",
                "type": "bytes32",
                "internalType": "bytes32"
              }
            ]
          },
          {
            "name": "p1Effects",
            "type": "tuple[][]",
            "internalType": "struct EffectInstance[][]",
            "components": [
              {
                "name": "effect",
                "type": "address",
                "internalType": "contract IEffect"
              },
              {
                "name": "stepsBitmap",
                "type": "uint16",
                "internalType": "uint16"
              },
              {
                "name": "data",
                "type": "bytes32",
                "internalType": "bytes32"
              }
            ]
          },
          {
            "name": "teams",
            "type": "tuple[][]",
            "internalType": "struct Mon[][]",
            "components": [
              {
                "name": "stats",
                "type": "tuple",
                "internalType": "struct MonStats",
                "components": [
                  {
                    "name": "hp",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "stamina",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "speed",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "attack",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "defense",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "specialAttack",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "specialDefense",
                    "type": "uint32",
                    "internalType": "uint32"
                  },
                  {
                    "name": "type1",
                    "type": "uint8",
                    "internalType": "enum Type"
                  },
                  {
                    "name": "type2",
                    "type": "uint8",
                    "internalType": "enum Type"
                  }
                ]
              },
              {
                "name": "ability",
                "type": "uint256",
                "internalType": "uint256"
              },
              {
                "name": "moves",
                "type": "uint256[]",
                "internalType": "uint256[]"
              }
            ]
          },
          {
            "name": "monStates",
            "type": "tuple[][]",
            "internalType": "struct MonState[][]",
            "components": [
              {
                "name": "hpDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "staminaDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "speedDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "attackDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "defenceDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "specialAttackDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "specialDefenceDelta",
                "type": "int32",
                "internalType": "int32"
              },
              {
                "name": "isKnockedOut",
                "type": "bool",
                "internalType": "bool"
              },
              {
                "name": "shouldSkipTurn",
                "type": "bool",
                "internalType": "bool"
              }
            ]
          },
          {
            "name": "globalKVEntries",
            "type": "tuple[]",
            "internalType": "struct GlobalKVEntry[]",
            "components": [
              {
                "name": "key",
                "type": "uint64",
                "internalType": "uint64"
              },
              {
                "name": "value",
                "type": "bytes32",
                "internalType": "bytes32"
              }
            ]
          },
          {
            "name": "p0Levels",
            "type": "tuple",
            "internalType": "struct TeamLevelInfo",
            "components": [
              {
                "name": "monIds",
                "type": "uint256[]",
                "internalType": "uint256[]"
              },
              {
                "name": "exp",
                "type": "uint256[]",
                "internalType": "uint256[]"
              },
              {
                "name": "levels",
                "type": "uint256[]",
                "internalType": "uint256[]"
              }
            ]
          },
          {
            "name": "p1Levels",
            "type": "tuple",
            "internalType": "struct TeamLevelInfo",
            "components": [
              {
                "name": "monIds",
                "type": "uint256[]",
                "internalType": "uint256[]"
              },
              {
                "name": "exp",
                "type": "uint256[]",
                "internalType": "uint256[]"
              },
              {
                "name": "levels",
                "type": "uint256[]",
                "internalType": "uint256[]"
              }
            ]
          }
        ]
      },
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct BattleData",
        "components": [
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "usesBuiltinManager",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "isTwoSlotMode",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "isMultiMode",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "activeMonExt",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "winnerIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "playerSwitchForTurnFlag",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "activeMonIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "lastExecuteTimestamp",
            "type": "uint40",
            "internalType": "uint40"
          },
          {
            "name": "turnId",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "numBuffered",
            "type": "uint8",
            "internalType": "uint8"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getBattleContext",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "ctx",
        "type": "tuple",
        "internalType": "struct BattleContext",
        "components": [
          {
            "name": "startTimestamp",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "winnerIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "turnId",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "playerSwitchForTurnFlag",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "p0ActiveMonIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "p1ActiveMonIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getBattleEndContext",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "ctx",
        "type": "tuple",
        "internalType": "struct BattleEndContext",
        "components": [
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "winner",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p0KOBitmap",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "p1KOBitmap",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "p0ActiveMonIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "p1ActiveMonIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "turnId",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "isMultiMode",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "p2",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p3",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p2TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p3TeamIndex",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "p0ActiveMonExtIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "p1ActiveMonExtIndex",
            "type": "uint8",
            "internalType": "uint8"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getBufferedSlotTurns",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "numExecuted",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "sideWords",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getBufferedTurns",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "numExecuted",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "packedTurns",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getDamageCalcContext",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "attackerPlayerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "attackerMonIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "defenderPlayerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "defenderMonIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "ctx",
        "type": "tuple",
        "internalType": "struct DamageCalcContext",
        "components": [
          {
            "name": "attackerMonIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "defenderMonIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "attackerAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attackerAttackDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "attackerSpAtk",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attackerSpAtkDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "defenderDef",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defenderDefDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "defenderSpDef",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defenderSpDefDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "defenderType1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "defenderType2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getEffectData",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "effectAddr",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "exists",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "effectIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "data",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getEffects",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple[]",
        "internalType": "struct EffectInstance[]",
        "components": [
          {
            "name": "effect",
            "type": "address",
            "internalType": "contract IEffect"
          },
          {
            "name": "stepsBitmap",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "data",
            "type": "bytes32",
            "internalType": "bytes32"
          }
        ]
      },
      {
        "name": "",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getGlobalKV",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "key",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint192",
        "internalType": "uint192"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getKOBitmap",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonCurrentValue",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "stateVarIndex",
        "type": "uint8",
        "internalType": "enum MonStateIndexName"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonHpState",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "maxHp",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "hpDelta",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonStateForBattle",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "stateVarIndex",
        "type": "uint8",
        "internalType": "enum MonStateIndexName"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonStatesForSide",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "states",
        "type": "tuple[]",
        "internalType": "struct MonState[]",
        "components": [
          {
            "name": "hpDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "staminaDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "speedDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "attackDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "defenceDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "specialAttackDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "specialDefenceDelta",
            "type": "int32",
            "internalType": "int32"
          },
          {
            "name": "isKnockedOut",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "shouldSkipTurn",
            "type": "bool",
            "internalType": "bool"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonStatsForBattle",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct MonStats",
        "components": [
          {
            "name": "hp",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "stamina",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "speed",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialDefense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "type1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "type2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonStatusClass",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonValueForBattle",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "stateVarIndex",
        "type": "uint8",
        "internalType": "enum MonStateIndexName"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMoveDecisionForSlot",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "slotIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct MoveDecision",
        "components": [
          {
            "name": "packedMoveIndex",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "extraData",
            "type": "uint16",
            "internalType": "uint16"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMoveForMonForBattle",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "moveIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getSeats",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "seats",
        "type": "address[4]",
        "internalType": "address[4]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getSlotSwitchWindow",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "slotIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "lo",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "hi",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "koBitmap",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getStorageKey",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTurnIdForBattleState",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getWinner",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "hasSlotActedThisTurn",
    "inputs": [
      {
        "name": "absSlot",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isMatchmakerFor",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "maker",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "pairHashNonces",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "removeEffect",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "indexToRemove",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "removeStatBoost",
    "inputs": [
      {
        "name": "targetIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "boostFlag",
        "type": "uint8",
        "internalType": "enum StatBoostFlag"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "resetCallContext",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setGlobalKV",
    "inputs": [
      {
        "name": "key",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "value",
        "type": "uint192",
        "internalType": "uint192"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setMove",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "moveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "salt",
        "type": "uint104",
        "internalType": "uint104"
      },
      {
        "name": "extraData",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setMoveForSlot",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "slotIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "moveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "extraData",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setPreDamage",
    "inputs": [
      {
        "name": "value",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "startBattle",
    "inputs": [
      {
        "name": "battle",
        "type": "tuple",
        "internalType": "struct Battle",
        "components": [
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p2",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p2TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p3",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p3TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "teamRegistry",
            "type": "address",
            "internalType": "contract ITeamRegistry"
          },
          {
            "name": "rngOracle",
            "type": "address",
            "internalType": "contract IRandomnessOracle"
          },
          {
            "name": "ruleset",
            "type": "address",
            "internalType": "contract IRuleset"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "matchmaker",
            "type": "address",
            "internalType": "contract IMatchmaker"
          },
          {
            "name": "engineHooks",
            "type": "address[]",
            "internalType": "contract IEngineHook[]"
          }
        ]
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "startBattleWithMode",
    "inputs": [
      {
        "name": "battle",
        "type": "tuple",
        "internalType": "struct Battle",
        "components": [
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p2",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p2TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p3",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p3TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "teamRegistry",
            "type": "address",
            "internalType": "contract ITeamRegistry"
          },
          {
            "name": "rngOracle",
            "type": "address",
            "internalType": "contract IRandomnessOracle"
          },
          {
            "name": "ruleset",
            "type": "address",
            "internalType": "contract IRuleset"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "matchmaker",
            "type": "address",
            "internalType": "contract IMatchmaker"
          },
          {
            "name": "engineHooks",
            "type": "address[]",
            "internalType": "contract IEngineHook[]"
          }
        ]
      },
      {
        "name": "battleMode",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "submitSlotTurnMoves",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "committerSidePacked",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "revealerSidePacked",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "r",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "vs",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "submitSlotTurnMovesAndExecute",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "committerSidePacked",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "revealerSidePacked",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "r",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "vs",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "submitTurnMoves",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "packedMoves",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "r",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "vs",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "submitTurnMovesAndExecute",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "packedMoves",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "r",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "vs",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "switchActiveMon",
    "inputs": [
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monToSwitchIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "switchActiveMonForSlot",
    "inputs": [
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "slotIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monToSwitchIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "tempRNG",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "updateMatchmakers",
    "inputs": [
      {
        "name": "makersToAdd",
        "type": "address[]",
        "internalType": "address[]"
      },
      {
        "name": "makersToRemove",
        "type": "address[]",
        "internalType": "address[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "updateMonState",
    "inputs": [
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "stateVarIndex",
        "type": "uint8",
        "internalType": "enum MonStateIndexName"
      },
      {
        "name": "valueToAdd",
        "type": "int32",
        "internalType": "int32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "validatePlayerMoveForBattle",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "moveIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "playerIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "extraData",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "BattleComplete",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "winner",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BattleCompleteWithBatchSlotTurns",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "payload",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BattleCompleteWithBatchTurns",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "payload",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BattleStart",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "p0",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "p1",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "EngineExecute",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "MonMoves",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "packedMoves",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "packedSalts",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "MovesSubmitted",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "packed",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SlotBattleStart",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "p0",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "p1",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "battleMode",
        "type": "uint8",
        "indexed": false,
        "internalType": "uint8"
      },
      {
        "name": "p2",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "p3",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SlotMovesSubmitted",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "side0Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "side1Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "BattleNotStarted",
    "inputs": []
  },
  {
    "type": "error",
    "name": "EmptyBuffer",
    "inputs": []
  },
  {
    "type": "error",
    "name": "GameAlreadyOver",
    "inputs": []
  },
  {
    "type": "error",
    "name": "GameStartsAndEndsSameBlock",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidBattleConfig",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidSignature",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MatchmakerNotAuthorized",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MovesNotSet",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoWriteAllowed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotBuiltInManager",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotCommitter",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotPlayerInBattle",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotSinglePlayerTurn",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotTwoPlayerTurn",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SideWordOverflow",
    "inputs": []
  },
  {
    "type": "error",
    "name": "StatRequiresStatBoost",
    "inputs": []
  },
  {
    "type": "error",
    "name": "WrongBattleMode",
    "inputs": []
  },
  {
    "type": "error",
    "name": "WrongCaller",
    "inputs": []
  }
] as const;
